// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RTkQ","col":"styles_col__3eJ9D","actions":"styles_actions__bsfOw","conflict":"styles_conflict__3YtIR"};